/**
 * Breakpoint tokens for responsive design
 *
 * Usage with MUI useMediaQuery:
 *   const isMobile = useMediaQuery(`(max-width: ${breakpoints.mobile}px)`);
 */
export const breakpoints = {
  /** Primary responsive breakpoint - switches to mobile layout */
  mobile: 600,

  /** Compact mobile layouts - reduced spacing/elements */
  compact: 465,

  /** Smallest supported width - minimal UI */
  minimal: 420,
} as const;

export type BreakpointToken = keyof typeof breakpoints;

/**
 * Media query helpers for common breakpoints
 */
export const mediaQueries = {
  mobile: `(max-width: ${breakpoints.mobile}px)`,
  compact: `(max-width: ${breakpoints.compact}px)`,
  minimal: `(max-width: ${breakpoints.minimal}px)`,
} as const;
